import type { TextProps } from '@opendoor/bricks-next';
import { Col, Row, Text } from '@opendoor/bricks-next';

type NavBarProps = {
  id?: string;
  title?: string;
  titleProps?: TextProps;
  subtitle?: string;
  subtitleProps?: TextProps;
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
};

const getNavBarTitleId = (props: Pick<NavBarProps, 'id'>) => {
  return `${props.id || 'navigation-bar'}-title`;
};

export const NavBar = ({
  id,
  title,
  titleProps,
  subtitle,
  subtitleProps,
  leftComponent,
  rightComponent,
}: NavBarProps) => {
  const hasTitle = !!(title || subtitle);

  return (
    <Row
      backgroundColor="$backgroundPrimary"
      px="$6x"
      py="$6x"
      $largerThanXS={{ px: '$12x', py: '$10x' }}
      flexGrow={1}
      flexShrink={1}
      alignItems="center"
      justifyContent="space-between"
      id={id}
    >
      <Row
        id={`${id}-navigation-bar-left-component`}
        justifyContent="flex-start"
        alignItems="center"
        flexShrink={2}
        minWidth={hasTitle ? 'auto' : 0}
        flexBasis={hasTitle ? '50%' : 'auto'}
      >
        {leftComponent}
      </Row>

      {(title || subtitle) && (
        <Col mx="$6x" flexShrink={1} minWidth={0} flexBasis="100%">
          <Text
            tag="h1"
            typography={subtitle ? '$labelMedium' : '$labelLarge'}
            textAlign="center"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            id={getNavBarTitleId({ id })}
            {...titleProps}
          >
            {title}
          </Text>

          {subtitle && (
            <Text
              tag="p"
              typography="$bodySmall"
              fontWeight="$regular"
              textAlign="center"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
              {...subtitleProps}
            >
              {subtitle}
            </Text>
          )}
        </Col>
      )}

      <Row
        id={`${id}-navigation-bar-right-component`}
        justifyContent="flex-end"
        alignItems="center"
        flexShrink={2}
        minWidth={hasTitle ? undefined : 0}
        flexBasis={hasTitle ? '50%' : 'auto'}
      >
        {rightComponent}
      </Row>
    </Row>
  );
};
